import * as locomotive from './locomotive';
import Swiper from 'swiper';

export default (node) => {

    var args = {
        slidesPerView: 1.2,
        spaceBetween: 20,

        breakpoints: {
            768: {
                slidesPerView: 2.2,
                spaceBetween: 20,
            },
            1025: {
                slidesPerView: 3.2,
            },
            1440: {
                slidesPerView: 4,
            }
        },

        loop: false,
        autoHeight: false,
        centeredSlides: false,
        grabCursor: true,
    }

    var slider = new Swiper(node, args);
    locomotive.update();
};